"use strict";

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildQueryString = exports.removeChildren = void 0;

var _fullscript = require("../fullscript");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var removeChildren = element => {
  while (element.firstChild) {
    element.firstChild.remove();
  }
};

exports.removeChildren = removeChildren;

var snakeCase = word => {
  return word.split(/(?=[A-Z])/g).map(w => w.toLowerCase()).join("_");
};

var snakeCaseObjectKeys = obj => {
  return Object.keys(obj).reduce((result, key) => _objectSpread(_objectSpread({}, result), {}, {
    [snakeCase(key)]: obj[key]
  }), {});
};

var tokenizeData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (patientInfo, fullscriptOptions) {
    try {
      var {
        env,
        domain
      } = fullscriptOptions;
      var fsDomain = domain !== null && domain !== void 0 ? domain : _fullscript.FULLSCRIPT_DOMAINS[env];
      var tokenizedInfo = yield fetch("".concat(fsDomain, "/api/embeddable/tokenize"), {
        method: "POST",
        body: JSON.stringify({
          data: patientInfo
        }),
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => res.json());
      if (typeof tokenizedInfo.data_token !== "string") throw new Error("Invalid response");
      return tokenizedInfo.data_token;
    } catch (error) {
      return null;
    }
  });

  return function tokenizeData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var buildQueryString = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (params) {
    if (!Object.keys(params) || Object.keys(params).length === 0) return "";

    var {
      patient: patientInfo,
      fullscriptOptions
    } = params,
        exposedParams = _objectWithoutProperties(params, ["patient", "fullscriptOptions"]);

    var startingQueryString = "?";

    if (patientInfo) {
      var snakeCasePatient = snakeCaseObjectKeys(patientInfo);
      var dataToken = yield tokenizeData(snakeCasePatient, fullscriptOptions);
      startingQueryString += "data_token=".concat(encodeURIComponent(dataToken), "&");
    }

    return Object.keys(exposedParams).reduce((queryString, key) => {
      var newParam = "".concat(snakeCase(key), "=").concat(exposedParams[key]);

      if (typeof exposedParams[key] !== "string") {
        newParam = Object.keys(exposedParams[key]).reduce((objectParams, attribute, currentIndex) => {
          var objectParam = "".concat(snakeCase(key), "[").concat(snakeCase(attribute), "]=").concat(encodeURIComponent(exposedParams[key][attribute]));

          if (currentIndex === 0) {
            return objectParam;
          }

          return "".concat(objectParams, "&").concat(objectParam);
        }, "");
      }

      if (queryString !== startingQueryString) {
        newParam = "&".concat(newParam);
      }

      return "".concat(queryString).concat(newParam);
    }, startingQueryString);
  });

  return function buildQueryString(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.buildQueryString = buildQueryString;